import type { Theme } from 'baseui'
import { pulseLighting } from '@/shared/theme/pulseLighting'
import { pulseRootState, pulseTextColor } from '../SDInput/styled-components'

interface TextareaStyleProps {
  $theme: Theme
  $error: boolean
  $isFocused: boolean
  $disabled: boolean
  $isReadOnly: boolean
}

export const SDTextareaPulseOverrides = (error?: string | boolean, missing?: boolean) => ({
  Root: {
    style: (props: TextareaStyleProps) => ({
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      boxShadow: pulseLighting(props.$theme).shadowPulseFocusIdle,
      transitionProperty: 'border, box-shadow, background-color',
      '@media (prefers-reduced-motion: reduce)': { transitionDuration: '0ms' },
      ...pulseRootState(props, error ?? props.$error, missing),
    }),
  },
  InputContainer: {
    style: {
      backgroundColor: 'transparent',
    },
  },
  Input: {
    style: (props: TextareaStyleProps) => ({
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '14px',
      lineHeight: '20px',
      color: pulseTextColor(props),
      '-webkit-text-fill-color': pulseTextColor(props),
      backgroundColor: 'transparent',
      resize: 'vertical',
      '::placeholder': {
        color: props.$theme.colors.textPulsePlaceholder,
      },
    }),
  },
})
